import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { MatDialogRef } from '@angular/material/dialog';
import { StoreCategoryService } from '@app/feature/store-admin/services/storeCategory/store-category.service';
//import { StoreCategoryService } from '@app/feature/super-admin/services/storeCategory/store-category.service';

@Component({
  selector: 'app-add-store-category',
  templateUrl: './add-store-category.component.html',
  styleUrls: ['./add-store-category.component.css']
})
export class AddStoreCategoryComponent implements OnInit {

  createCategoryForm: FormGroup;
  storeCategoryData:any=[];
  storeCategoryId:any;
  constructor(private _fb: FormBuilder, private loader: LoaderService, private notification: NotificationService,
    private dialogRef: MatDialogRef<AddStoreCategoryComponent>, private storeCategoryService: StoreCategoryService) {
    this.createCategoryForm = this._fb.group({
      CategoryName: ['', Validators.required],
      Description: ['', Validators.required],
      StoreCategoryId: ['0'],
      Type: ['Add'],
    });
   }

  ngOnInit() {
  }


    // convenience getter for easy access to form fields
    get f() {
      return this.createCategoryForm.controls;
    }

    fn_Cancel() {
      this.dialogRef.close({
        data: false
      });
    }

    fn_CreateCategory(form: FormGroup) {
      const storeCategoryData = form.value;
      storeCategoryData.UserId = localStorage.getItem('userId');
      this.storeCategoryService.CreateCategory(storeCategoryData).subscribe((res: any) => {
        if (res.StatusCode === 200) {
          this.storeCategoryData=res.Data.ResponseData;
          this.storeCategoryId=res.Data.ResponseData.StoreCategoryId;
          this.dialogRef.close({
            data: this.storeCategoryId
          });
          this.notification.success(res.Message, 'Success');
        } else if (res.StatusCode === 203) {
          this.dialogRef.close({
            data: false
          });
          this.notification.error('An error occured. Try Again', 'Error');
        }
        else if(res.StatusCode===400){
          this.notification.error(res.Message,'Error');
        }
      }, (err: any) => {
        this.dialogRef.close({
          data: false
        });
        this.notification.error('An error occured', 'Error');
      });
    }
}
